<template>
  <div>
    <!-- <v-card>
      <v-card-text> -->
        <v-data-table
          :headers="headers"
          :items="listasStore.registros_whatsapp"
          hide-default-footer
          :fixed-header="props.fixedHeader"
          :height="props.fixedHeader == true ? 450 : 'auto'"
          disable-sort
        >
          <template #item="{ item }">
            <tr>
              <td>{{ item.id }}</td>
              <td>{{ item.datahora | dataHoraBR }}</td>
              <td>{{ item.celular }}</td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :color="getStatusColor(item.status_envio)">{{ getIcon(item.status_envio) }} </v-icon>
                  </template>
                  <span>{{ getStatusText(item.status_envio) }}</span>
                </v-tooltip>
              </td>
              <td>{{ item.cliente_nome }}</td>
              <td class="text-right">{{ item.valor | valorBR }}</td>
              <!-- <td class="text-no-wrap">
                <div v-if="item.conta_id">
                  <div class="font-weight-bold">Conta</div>
                  Banco: {{ item.conta.banco.descricao }}<br>
                  Agencia/Conta: {{ item.conta.agencia }} / {{ item.conta.numero_conta }}<br>
                  Titular: {{ item.conta.titular }}
                </div>
                <div v-if="item.chavepix_id">
                  <div class="font-weight-bold">Chave Pix</div>
                  Chave: {{ item.chavepix.chave }}<br>
                  Tipo: {{ item.chavepix.tipo }}<br>
                  Titular: {{ item.chavepix.titular }}
                </div>
              </td> -->
            </tr>
          </template>
        </v-data-table>
        
      <!-- </v-card-text>
    </v-card> -->

  </div>
</template>

<script setup>
import { ref, computed, getCurrentInstance, onMounted, inject, watch } from 'vue';
import { useListasStore } from '@/app/store/pinia/listas.js';

const props = defineProps({
  fixedHeader: {
    type: Boolean,
    default: true
  },
});

const listasStore = useListasStore();
const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $globals = proxy.$globals;
const $notificacao = inject('notificacao');

const headers = [
  { text: '#', value: 'id' },
  { text: 'Data', value: 'datahora' },
  { text: 'Celular', value: 'celular' },
  { text: 'Status', value: 'status_envio', align: 'center' },
  { text: 'Cliente', value: 'cliente_nome' },
  { text: 'Valor', value: 'valor', align: 'right' },
  // { text: 'Chave Pix/Conta', value: 'chavepix' },
];


function getStatusText(status_envio) {
  const statusTexts = {
    'SERVER_ACK': 'Pendente',
    'PENDING': 'Pendente',
    'DELIVERY_ACK': 'Entregue',
    'READ': 'Lida',
  };

  return statusTexts[status_envio] || 'Desconhecido';
}

function getStatusColor(status_envio) {
  const statusColors = {
    'SERVER_ACK': 'grey',
    'PENDING': 'grey',
    'DELIVERY_ACK': 'grey',
    'READ': 'blue',
  };

  return statusColors[status_envio] || 'grey';
}

function getIcon(status_envio) {
  const statusIcons = {
    'SERVER_ACK': proxy.$icon.WHATSAPP_PENDING,
    'PENDING': proxy.$icon.WHATSAPP_PENDING,
    'DELIVERY_ACK': proxy.$icon.WHATSAPP_DELIVERED,
    'READ': proxy.$icon.WHATSAPP_READ,
  };

  return statusIcons[status_envio] || proxy.$icon.WHATSAPP_READ;
};

const items = ref([]);


</script>

<style lang="scss" scoped>

  :deep(.v-data-table tbody) {
    vertical-align: top;
    tr {
      td {
        padding-top: 8px !important;
      }
    }
  }

</style>